module.exports = __webpack_public_path__ + "img/img_cmag2.25d271e5.png";